// Shared IANA timezone list and label helper.
// Used by VennBooking (customer-facing) and OnboardingModal (business setup).

export const COMMON_TIMEZONES = [
  'Pacific/Honolulu',
  'America/Anchorage',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/Halifax',
  'America/Sao_Paulo',
  'Atlantic/Azores',
  'Europe/London',
  'Europe/Dublin',
  'Europe/Lisbon',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Rome',
  'Europe/Stockholm',
  'Europe/Athens',
  'Europe/Helsinki',
  'Africa/Cairo',
  'Africa/Nairobi',
  'Asia/Dubai',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Colombo',
  'Asia/Dhaka',
  'Asia/Rangoon',
  'Asia/Bangkok',
  'Asia/Singapore',
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Australia/Perth',
  'Australia/Darwin',
  'Australia/Adelaide',
  'Australia/Sydney',
  'Pacific/Auckland',
  'Pacific/Fiji',
];

/** Format an IANA timezone as "City (UTC+N)" for display. */
export function tzLabel(tz) {
  try {
    const offset = new Date()
      .toLocaleString('en-US', { timeZone: tz, timeZoneName: 'shortOffset' })
      .split(' ')
      .pop();
    const city = tz.split('/').pop().replace(/_/g, ' ');
    return `${city} (${offset})`;
  } catch {
    return tz;
  }
}
